import { ITokenObject } from '@helipagos/auth';
import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = (valuePassed?: string): boolean => {
  try {
    if (valuePassed?.length === 0) {
      return true;
    }
    const value = valuePassed ?? '';
    const decodedToken: ITokenObject = jwtDecode(value);
    const expiry = new Date(decodedToken.exp * 1000);
    const now = Date.now();
    return expiry.getTime() <= now;
  } catch (e) {
    return true;
  }
};
